export var KYC_USER_FETCH_REQUEST = 'KYC_USER_FETCH_REQUEST';
export var KYC_USER_FETCH_SUCCESS = 'KYC_USER_FETCH_SUCCESS';
export var KYC_USER_FETCH_FAIL = 'KYC_USER_FETCH_FAIL';
export var KYC_USER_UPDATE_REQUEST = 'KYC_USER_UPDATE_REQUEST';
export var KYC_USER_UPDATE_SUCCESS = 'KYC_USER_UPDATE_SUCCESS';
export var KYC_USER_UPDATE_FAIL = 'KYC_USER_UPDATE_FAIL';
export var KYC_USER_FILES_REQUEST = 'KYC_USER_FILES_REQUEST';
export var KYC_USER_FILES_SUCCESS = 'KYC_USER_FILES_SUCCESS';
export var KYC_USER_FILES_FAIL = 'KYC_USER_FILES_FAIL';
export var KYC_USER_FILE_UPDATE_REQUEST = 'KYC_USER_FILE_UPDATE_REQUEST';
export var KYC_USER_FILE_UPDATE_SUCCESS = 'KYC_USER_FILE_UPDATE_SUCCESS';
export var KYC_USER_FILE_UPDATE_FAIL = 'KYC_USER_FILE_UPDATE_FAIL';
export var KYC_USER_ANSWERS_REQUEST = 'KYC_USER_ANSWERS_REQUEST';
export var KYC_USER_ANSWERS_SUCCESS = 'KYC_USER_ANSWERS_SUCCESS';
export var KYC_USER_ANSWERS_FAIL = 'KYC_USER_ANSWERS_FAIL';
export var KYC_USER_ANSWERS_UPDATE_REQUEST = 'KYC_USER_ANSWERS_UPDATE_REQUEST';
export var KYC_USER_ANSWERS_UPDATE_SUCCESS = 'KYC_USER_ANSWERS_UPDATE_SUCCESS';
export var KYC_USER_ANSWERS_UPDATE_FAIL = 'KYC_USER_ANSWERS_UPDATE_FAIL';
